export default __webpack_public_path__ + "static/media/Uae_total_registration.9fa709e4.svg";